import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetChallengeTriageDetailRequest } from './get-challenge-triage-detail-request';
import type { IGetChallengeTriageDetailResponse } from './get-challenge-triage-detail-response';
import { getChallengeTriageDetailResponseSchema } from './get-challenge-triage-detail-response';

export async function getChallengeTriageDetailApi({
  challengeId,
  lang,
}: IGetChallengeTriageDetailRequest): Promise<
  IValidatedResponse<IGetChallengeTriageDetailResponse>
> {
  return getRequest<IGetChallengeTriageDetailResponse>({
    path: `/sys/challenge-issues/challenge/${challengeId}/triage-detail/v1`,
    schema: getChallengeTriageDetailResponseSchema,
    options: { params: { lang } },
  });
}
